import moment from 'moment';

export const validateInteger = () => (value) => {
  if (!value || Number.isInteger(Number(value))) {
    return { integer: '' };
  }
  return { integer: 'This field can only contain numbers' };
};

export const validateIntegerWeight = () => (value) => {
  if (!value || /^\d+(\.\d{1,2})?$/.test(value)) {
    return { integer: '' };
  }
  return { integer: 'This field can only contain numbers' };
};

export const validateLetterNumberSpecialCharacter = () => (value) => {
  if (!value || /^["'_-]|[^0-9\W][\w\W]*/.test(value)) {
    return { valid: '' };
  }

  return { valid: 'Validation not correct' };
};

export const validateDateObject = () => (value) => {
  if (value) {
    return { value: '' };
  }
  return {
    value: 'Date format must look like 02/28/2002',
  };
};

const smartConverted = (smart) => smart.replace('”', '"').replace('’', "'");

export const validateHeight = () => (value) => {
  if (
    !value ||
    (value &&
      /[3-7]{1}\'([0-9]{1,2}(.[0-9]{1})?\")?$/.test(smartConverted(value)))
  ) {
    return { value: '' };
  }
  return {
    value: "Height format must look like 6' or 6'7\"",
  };
};

export const validateNumber = () => (value) => {
  if (!value || !Number.isNaN(Number(value))) {
    return { number: '' };
  }
  return {
    number: 'This field can only contain numbers and dot as decimal separator',
  };
};
export const validateDecimalToOnePositionNumber = () => (value) => {
  if (!value || (!Number.isNaN(Number(value)) && countDecimals(value))) {
    return { integer: '' };
  }
  return {
    integer: 'This field can only contain numbers and decimal upto 1 character',
  };
};

const countDecimals = (value) => {
  value = parseFloat(value);
  if (Math.floor(value) === value) return 1;
  const length = value.toString().split('.')[1].length || 0;
  return length < 2;
};

export const validateMaxLength = (length) => (value) =>
  !value || (value && value.length < length)
    ? { length: '' }
    : { length: `This field can be a maximum of ${length} characters long` };

export const validateJersey = () => (value) =>
  !value || (value && /^[a-zA-Z0-9- '",_]*$/.test(value))
    ? { jerseyNumbers: '' }
    : { jerseyNumbers: 'This field can only take numbers, commas and spaces.' };

export const validateBatsRequired = (sportId) => (value) => {
  if (sportId === 2 || sportId === 4) {
    return !value ? { msg: 'This field is required' } : { msg: '' };
  }
  return { msg: '' };
};
export const validateLength = (length) => (value) =>
  value && value.length >= length
    ? { length: '' }
    : { length: `This field must be at least ${length} characters long` };

export const validatePasswordLength = (length) => (value) => {
  if (value.length < 6) {
    return {
      length: `This password must be at least ${length} characters long`,
    };
  } else if (value.substring(0, 5) === '     ') {
    return { length: `Passoword should contain at least one latter` };
  }

  return { length: '' };
};
// value && value.length >= length
//   ? { length: '' }
//   : { length: `This password must be at least ${length} characters long` };

export const validateNotRequiredMinLength = (length) => (value) => {
  if (value && value.length <= length) {
    return {
      length: `This field must be at least ${length} characters long`,
    };
  }
  return {
    length: '',
  };
};
export const validateRequired = (msg) => (value) => {
  return value
    ? { required: '' }
    : { required: msg || 'This field is required' };
};

export const validateHourTime = (msg) => (value) => {
  if (!/(^([0-9]+):([0-9]+)$)/.test(value)) {
    return { required: 'Must be in the format 00:00' };
  }
  return { required: '' };
};

// Note: the benefit of this method is that it *fails* on a zero value
export const validateRequiredNonZeroNumber = (msg) => (value) => {
  return Number(value)
    ? { required: '' }
    : { required: msg || 'This field must contain a numeric value' };
};

export const validateRequiredNonZeroNumberAndMinimum = (form) => (value) => {
  if(!Number(value)){
    return  { required: 'This field must contain a numeric value' }
  }
  if(form.testRange){
    const min = Number(form.testRange.min);
    const input = Number(value);
    if(input < min){
      return { required: `Oops! This field's value should not be less than ${min}.` };
    }
  }else{
    return { required: '' }
  }
  return { required: '' }
};
export const validateRequiredDegree = (msg) => (value) => {
  if (/[-\d.]/.test(value)) {
    return { required: '' };
  }
  return { required: msg || 'This field must be numeric integer' };
};
export const validateEmail = () => (value) =>
  !value ||
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    String(value).toLowerCase().trim(),
  )
    ? { email: '', parentEmail: '' }
    : {
        email: 'Please enter a valid email',
        parentEmail: 'Please enter a valid email',
      };

export const validateEmailOrPhoneRequired = () => (phone, email) =>
  !phone && !email
    ? { emailOrPhoneRequired: 'Either a phone or an email is required' }
    : { emailOrPhoneRequired: '' };
export const validatePhone = () => (value) => {
  if (!value) return { phone: '' };
  const { length } = value.replace(/[^0-9]+/g, '');
  return ((value[0] === '+' && length > 10) || length > 9) && length <= 13
    ? { phone: '' }
    : { phone: 'Please enter a valid phone number' };
};
export const validateSAPhone = () => (value) => {
  if (!value) return { phone: '' };
  const { length } = value.replace(/[^0-9]+/g, '');
  return (value[0] === '+' && length > 9) || length === 9
    ? { phone: '' }
    : { phone: 'Please enter a valid phone number' };
};
export const validateRequiredIfUsernameNull = () => (username, value) =>
  !username ? validateRequired()(value) : { length: '' };
export const validateIsPhoneOrEmail = () => (value) =>
  validateEmail()(value).email === '' || validatePhone()(value).phone === ''
    ? { phoneOrEmail: '' }
    : { phoneOrEmail: 'Please enter a valid email' };
export const validatePassword = (length) => (value) => {
  if (value) {
    if (value.length < length) {
      return {
        length: `This password must be at least ${length} characters long`,
      };
    } else if (value.substring(0, 5) === '     ') {
      return { length: `Password should contain al least one latter` };
    }
    return { length: '' };
  }
  return { length: 'This field is required' };
};
export const validateConfirmPassword = () => (password, confirmPassword) => {
  return password === confirmPassword
    ? { match: '' }
    : { match: 'Passwords do not match' };
};

export const validateConfirmUsername = () => (username, confirmUsername) =>
  username === confirmUsername
    ? { match: '' }
    : { match: 'Emails do not match' };

export const validateParentsEmail = () => (username, confirmUsername) =>
  username === confirmUsername
    ? { match: '' }
    : { match: 'Parent Emails do not match' };

export const validateParent2Email = () => (username, confirmUsername) =>
  username === confirmUsername
    ? { match: '' }
    : { match: 'Parent 2 Emails do not match' };

export const validateConfirmPhone = () => (phone, confirmPhone) => {
  return (!phone && !confirmPhone) || phone === confirmPhone
    ? { match: '' }
    : { match: 'Phone Numbers do not match' };
};
export const validateConfirmPhone2 = () => (phone, confirmPhone) => {
  return (!phone && !confirmPhone) || phone === confirmPhone
    ? { match: '' }
    : { match: 'Phone 2 Numbers do not match' };
};

// New Password Validation
export const validatePasswordUppercase = () => (value) =>
  value && value.toLowerCase() !== value
    ? { passwordUppercase: '' }
    : {
        passwordUppercase: 'Password must contain at least 1 uppercase letter',
      };
export const validatePasswordLowercase = () => (value) =>
  value && value.toUpperCase() !== value
    ? { passwordLowercase: '' }
    : {
        passwordLowercase: 'Password must contain at least 1 lowercase letter',
      };
export const validatePasswordNumber = () => (value) =>
  value && /[0-9]/.test(value)
    ? { passwordNumber: '' }
    : { passwordNumber: 'Password must contain at least 1 number' };
export const validatePasswordSpecialChar = () => (value) =>
  value && /[-!$%^&*()_@#+|~=`{}[\]:";'<>?,./]/.test(value)
    ? { passwordSpecialChar: '' }
    : {
        passwordSpecialChar:
          'Password must contain at least 1 special character',
      };

export const validateSeasonDates = () => (seasonEnd, seasonStart) => {
  if (!seasonStart) return { order: '' };
  if (!seasonEnd) return { order: '' };
  return seasonStart.isBefore(seasonEnd)
    ? { order: '' }
    : {
        order:
          'Please select a season end date that is after the season start date',
      };
};
export const validateOneOfIsRequired = (errorMsg) => (values) => {
  let oneOf = false;
  values.forEach((value) => {
    if (value) {
      oneOf = true;
    }
  });
  if (oneOf) {
    return { oneOf: '' };
  }
  return { oneOf: errorMsg };
};
export const validateUrl = () => (value) =>
  !value ||
  // eslint-disable-next-line
  /^[a-z](?:[-a-z0-9\+\.])*:(?:\/\/(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~\uA0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\u10000-\u1FFFD\u20000-\u2FFFD\u30000-\u3FFFD\u40000-\u4FFFD\u50000-\u5FFFD\u60000-\u6FFFD\u70000-\u7FFFD\u80000-\u8FFFD\u90000-\u9FFFD\uA0000-\uAFFFD\uB0000-\uBFFFD\uC0000-\uCFFFD\uD0000-\uDFFFD\uE1000-\uEFFFD!\$&'\(\)\*\+,;=:])*@)?(?:\[(?:(?:(?:[0-9a-f]{1,4}:){6}(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|::(?:[0-9a-f]{1,4}:){5}(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|(?:[0-9a-f]{1,4}:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|v[0-9a-f]+[-a-z0-9\._~!\$&'\(\)\*\+,;=:]+)\]|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3}|(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~\uA0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\u10000-\u1FFFD\u20000-\u2FFFD\u30000-\u3FFFD\u40000-\u4FFFD\u50000-\u5FFFD\u60000-\u6FFFD\u70000-\u7FFFD\u80000-\u8FFFD\u90000-\u9FFFD\uA0000-\uAFFFD\uB0000-\uBFFFD\uC0000-\uCFFFD\uD0000-\uDFFFD\uE1000-\uEFFFD!\$&'\(\)\*\+,;=@])*)(?::[0-9]*)?(?:\/(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~\uA0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\u10000-\u1FFFD\u20000-\u2FFFD\u30000-\u3FFFD\u40000-\u4FFFD\u50000-\u5FFFD\u60000-\u6FFFD\u70000-\u7FFFD\u80000-\u8FFFD\u90000-\u9FFFD\uA0000-\uAFFFD\uB0000-\uBFFFD\uC0000-\uCFFFD\uD0000-\uDFFFD\uE1000-\uEFFFD!\$&'\(\)\*\+,;=:@]))*)*|\/(?:(?:(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~\uA0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\u10000-\u1FFFD\u20000-\u2FFFD\u30000-\u3FFFD\u40000-\u4FFFD\u50000-\u5FFFD\u60000-\u6FFFD\u70000-\u7FFFD\u80000-\u8FFFD\u90000-\u9FFFD\uA0000-\uAFFFD\uB0000-\uBFFFD\uC0000-\uCFFFD\uD0000-\uDFFFD\uE1000-\uEFFFD!\$&'\(\)\*\+,;=:@]))+)(?:\/(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~\uA0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\u10000-\u1FFFD\u20000-\u2FFFD\u30000-\u3FFFD\u40000-\u4FFFD\u50000-\u5FFFD\u60000-\u6FFFD\u70000-\u7FFFD\u80000-\u8FFFD\u90000-\u9FFFD\uA0000-\uAFFFD\uB0000-\uBFFFD\uC0000-\uCFFFD\uD0000-\uDFFFD\uE1000-\uEFFFD!\$&'\(\)\*\+,;=:@]))*)*)?|(?:(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~\uA0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\u10000-\u1FFFD\u20000-\u2FFFD\u30000-\u3FFFD\u40000-\u4FFFD\u50000-\u5FFFD\u60000-\u6FFFD\u70000-\u7FFFD\u80000-\u8FFFD\u90000-\u9FFFD\uA0000-\uAFFFD\uB0000-\uBFFFD\uC0000-\uCFFFD\uD0000-\uDFFFD\uE1000-\uEFFFD!\$&'\(\)\*\+,;=:@]))+)(?:\/(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~\uA0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\u10000-\u1FFFD\u20000-\u2FFFD\u30000-\u3FFFD\u40000-\u4FFFD\u50000-\u5FFFD\u60000-\u6FFFD\u70000-\u7FFFD\u80000-\u8FFFD\u90000-\u9FFFD\uA0000-\uAFFFD\uB0000-\uBFFFD\uC0000-\uCFFFD\uD0000-\uDFFFD\uE1000-\uEFFFD!\$&'\(\)\*\+,;=:@]))*)*|(?!(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~\uA0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\u10000-\u1FFFD\u20000-\u2FFFD\u30000-\u3FFFD\u40000-\u4FFFD\u50000-\u5FFFD\u60000-\u6FFFD\u70000-\u7FFFD\u80000-\u8FFFD\u90000-\u9FFFD\uA0000-\uAFFFD\uB0000-\uBFFFD\uC0000-\uCFFFD\uD0000-\uDFFFD\uE1000-\uEFFFD!\$&'\(\)\*\+,;=:@])))(?:\?(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~\uA0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\u10000-\u1FFFD\u20000-\u2FFFD\u30000-\u3FFFD\u40000-\u4FFFD\u50000-\u5FFFD\u60000-\u6FFFD\u70000-\u7FFFD\u80000-\u8FFFD\u90000-\u9FFFD\uA0000-\uAFFFD\uB0000-\uBFFFD\uC0000-\uCFFFD\uD0000-\uDFFFD\uE1000-\uEFFFD!\$&'\(\)\*\+,;=:@])|[\uE000-\uF8FF\uF0000-\uFFFFD\u100000-\u10FFFD\/\?])*)?(?:\#(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~\uA0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\u10000-\u1FFFD\u20000-\u2FFFD\u30000-\u3FFFD\u40000-\u4FFFD\u50000-\u5FFFD\u60000-\u6FFFD\u70000-\u7FFFD\u80000-\u8FFFD\u90000-\u9FFFD\uA0000-\uAFFFD\uB0000-\uBFFFD\uC0000-\uCFFFD\uD0000-\uDFFFD\uE1000-\uEFFFD!\$&'\(\)\*\+,;=:@])|[\/\?])*)?$/i
    // /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/
    .test(value)
    ? { url: '' }
    : { url: 'Please enter a valid url' };
export const validateLetters = () => (value) =>
  !value ||
  (value &&
    /^[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEFa-zA-Z'][\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEFa-zA-Z' -]*$/.test(
      value,
    ))
    ? { letters: '' }
    : {
        letters:
          'This field can only contain letters  spaces and few special character',
      };
export const validateName = () => (value) =>
  !value ||
  (value &&
    /^[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEFa-zA-Z'][\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEFa-zA-Z -']*$/.test(
      value,
    ))
    ? { letters: '' }
    : {
        letters:
          'This field can only contain letters  spaces and few special character',
      };

export const validateAlphaNumeric = () => (value) => {
  if (!value || /^[A-Z0-9 _]*[A-Z0-9][A-Z0-9 _]*$/i.test(value)) {
    return { valid: '' };
  }
  return { valid: 'Validation not correct' };
};

export const validateLettersWithRMSpecialCharacter = () => (value) => {
  if (!value || (value && /^[a-zA-Z0-9\s-_'."]*$/i.test(value))) {
    return { letters: '' };
  }
  return { letters: 'Validation not correct' };
};

export const validateRMSpecialCharacter = () => (value) => {
  if (!value || /^[A-Z0-9 _]*[A-Z0-9][A-Z0-9 _][A-Z0-9-'"]*$/i.test(value)) {
    return { valid: '' };
  }
  return { valid: 'Validation not correct' };
};

export const validateAlphaNumericWithSpecialCharacter = () => (value) => {
  if (!value || /^[a-zA-Z0-9- '",_]*$/.test(value)) {
    return { valid: '' };
  }
  return { valid: 'Validation not correct' };
};

export const validateJerseyNumber = () => (value) => {
  if (!value || /^[\d]|[-_'"]/.test(value)) {
    return { valid: '' };
  }
  return { valid: 'Validation not correct' };
};

export const validateCombineNumber = () => (value) => {
  if (!value || /^[\d]|[-_'"]/.test(value)) {
    return { valid: '' };
  }
  return { valid: 'Validation not correct' };
};

export const validateHeightFtInteger = () => (value) => {
  if (!value || /^[0-9']*$/.test(value)) {
    return { integer: '' };
  }
  return { integer: "This field can only contain numbers and quote ex: 5'  " };
};

export const validateHeightInchInteger = () => (value) => {
  // if (!value ||  (/^[0-9."]*$/).test(value)) {
  if (!value || /^(\d*)\.{0,1}(\d){0,2}(\"){0,1}$/.test(value)) {
    return { integer: '' };
  }
  return { integer: 'This field can only contain numbers and quote ex: 5" ' };
};

export const socialHandleValidation = () => (value) => {
  if (
    !value ||
    /^([A-Za-z0-9_@](?:(?:[A-Za-z0-9_]|(?:\.(?!\.))){0,28}(?:[A-Za-z0-9_]))?)$/.test(
      value,
    )
  ) {
    return { valid: '' };
  }
  return { valid: 'Not valid' };
};

export const validateTwitter = () => (value) => {
  if (
    !value ||
    /^([A-Za-z0-9_@](?:(?:[A-Za-z0-9_]){0,15}(?:[A-Za-z0-9_]))?)$/.test(value)
  ) {
    return { valid: '' };
  }
  return { valid: 'Not valid' };
};

export const addressValidation = () => (value) => {
  if (!value || /^[a-zA-Z0-9 ^*,.()":;'-@&\s_]*$/.test(value)) {
    return { valid: '' };
  }
  return { valid: 'Not Valid' };
};

export const validateGradYear = () => (value) => {
  // /^[0-9][0-9a-zA-Z- '",_]*/  if grad year should start with number
  if (!value || /^[0-9]{4}[0-9a-zA-Z- '",_]*/.test(value)) {
    return { valid: '' };
  }
  return { valid: 'Grad year should start with integer' };
};

export const validateZipcode = () => (value) => {
  if (Number.isInteger(Number(value)) && value.length < 6) {
    return { integer: '' };
  }
  return { integer: 'This field can only contain numbers upto 5 digits' };
};

export const validateBirthday = () => (value) => {
  const date = value.date ? value.date : value;
  const dateWrapper = new moment(date, 'MM/DD/YYYY');
  if (dateWrapper.isValid()) {
    return { valid: '' };
  }
  return { valid: 'Invalid Date' };
};

export const formatPositionResponse = (str) => {
  return str.replace(/^,/, '').split(',').join(', ');
};

export const capitalizeLetterAfterSpaceHyphen = (str) => {
  return str.replace(/(^\w{1})|(\s+\w{1})|(-+\w{1})/g, (letter) =>
    letter.toUpperCase(),
  );
};

export const getCoachAllSportsData = (sports, coachAllSportsIds = null) => {
  let coachSportsData = [];
  if (coachAllSportsIds === null) {
    return null;
  }
  sports.map((ele) => {
    if (coachAllSportsIds.includes(ele.id)) {
      coachSportsData.push({
        name: ele.name,
        value: ele.id,
      });
    }
  });
  return coachSportsData;
};
